import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { GabaritService } from '../gabarit/gabarit.service';
import { Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class GestionTitreService {
  private readonly translateService = inject(TranslateService);
  private readonly titleService = inject(Title);
  private readonly gabaritService = inject(GabaritService);

  addTitreOnglet(dcr: string) {
    if (this.gabaritService.isAppMobile() && dcr.includes('titreOnglet')) {
      dcr = 'titreOnglet.mobile';
    }
    this.translateService.get(dcr).subscribe((texte: string) => this.titleService.setTitle(texte));
  }
}
